import Api from '@/helpers/api';
/**
 * Obtiene la lista de Claves
 *
 * @returns {Promise<KeyChains>} Promise - una promesa con la lista de Claves // Error
 */
const getAllConnections = async () => {
    const result = await Api.get('/connections');
    return result.data;
};

/**
 * Obtiene una Clave, por su ID.
 *
 * @param {string} id - el Id de la Clave
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const getOneConnection = async (id) => {
    const result = await Api.get(`/connections/${id}`);
    return result.data;
};

/**
 * Guarda una Clave
 *
 * @param {object} conn - un objeto con los datos de la Clave a guardar
 * @returns {Promise<Connections>} Promise - una promesa con el estado del servicio // Error
 */
const saveConnection = async (conn) => {
    const result = await Api.post('/connections', conn);
    return result.data;
};

/**
 * Actualiza una Clave
 *
 * @param {string} id - el Id de la Clave
 * @param {object} keyChain - un objeto con los datos de la Clave a actualizar
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const updateConnection = async (id, keyChain) => {
    const result = await Api.put(`/connections/${id}`, keyChain);
    return result.data;
};

/**
 * Elimina una Clave
 *
 * @param {string} id - el Id de la Clave
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const deleteConnection = async (id) => {
    const result = await Api.delete(`/connections/${id}`);
    return result.data;
};


export {
    getAllConnections,
    getOneConnection,
    saveConnection,
    updateConnection,
    deleteConnection
};
